import React from "react";

import styles from "./styles/Layout.module.scss";

import _ from "lodash";
import { Col, Row } from "react-bootstrap";
import { useChatContext } from "../context/ChatContext";
import ChatThreads from "./ChatThreads";
import Inbox from "./Inbox";
import { SubTitle } from "Components/CustomComponents";

const DesktopLayout: React.FC = () => {
  const { chatRoom } = useChatContext();

  return (
    <div className={styles.Layout}>
      <Row className={styles.row}>
        <Col className={styles.col} md={8}>
          {
            !_.isEmpty(chatRoom) ?
              <Inbox key={chatRoom?.chat_room_id} /> :
              <div className="make-center">
                <SubTitle
                  text={"No Chat Selected"}
                />
              </div>
          }
        </Col>
        <Col className={styles.col} md={4}>
          <ChatThreads />
        </Col>
      </Row>
    </div>
  );
}

export default DesktopLayout
